const orgClass = {
  BUSINESS: "business",
  RIDER: "rider"
};
Object.freeze(orgClass);
export default orgClass;
